import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { HowIHelp } from '../components/HowIHelp';
import { Process } from '../components/Process';
import { ExampleWins } from '../components/ExampleWins';
import { About } from '../components/About';
import { BookCall } from '../components/BookCall';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0a0a] font-sans text-gray-900 selection:bg-orange-100 selection:text-orange-900" data-id="element-238">
      <Navigation data-id="element-239" />
      <main data-id="element-240">
        <Hero data-id="element-241" />
        <HowIHelp data-id="element-242" />
        <Process data-id="element-243" />
        <ExampleWins data-id="element-244" />
        <About data-id="element-245" />
        <BookCall data-id="element-246" />
        <FAQ data-id="element-247" />
      </main>
      <Footer data-id="element-248" />
    </div>;
}